import React from 'react'
import BEMHelper from 'react-bem-helper'
import { Link } from 'react-router-dom'

import { Grid, Col } from '../../components/Grid'
import Contact from '../../components/Contact'
import List from '../../components/List'
import './index.css'
import cases from '../../data/cases'
import Helmet from '../../components/seo/Helmet'

const classes = new BEMHelper('arbeiderpartiet')

export default function Arbeiderpartiet ({ helmetProps }) {
  const info = cases.find(({ slug }) => slug === 'arbeiderpartiet')
  const { name, preamble, description } = info

  return (
    <article {...classes('')}>
      <Helmet {...helmetProps} />
      <h1 {...classes('title')}>{name}</h1>

      <Grid>
        <Col>
          <p>
            <em>{preamble}</em>
          </p>

          <p dangerouslySetInnerHTML={{ __html: description.props.children }} />
        </Col>

        <Col>
          <p>
            Arbeiderpartiets nettsider og intranett utvikles og driftes av
            Appresso AS. Nettsidene er bygget som en plattform hvor man enkelt
            kan legge til nye nettsteder med egne domener og egne
            administratorer. For Arbeiderpartiet innebærer det i tillegg til
            hovedsiden egne sider for alle fylkes-, kommune- og lokallag. Per i
            dag består den av over 100.000 sider fordelt på mer enn 600
            nettsteder. For Arbeiderpartiet og Appresso er tilgjengelighet
            veldig viktig, og nettsidene er designet for dette fra bunnen av.
            Dette gjør at sidene tilfredsstiller alle krav fra Difi og WCAG.
          </p>

          <p>
            I tillegg inneholder plattformen Arbeiderpartiets intranettsider og
            en lang rekke produktivitets- og samarbeidsverktøy.
          </p>

          <p>
            Plattformen er bygget med Python og Django, og ikke minst med
            Appressos egenutviklede <Link to="/rammeverk">IEVV rammeverk</Link>.
            Det er et omfattende system, med integrasjoner mot ERP-systemer og
            sosiale medier. Plattformen tilbyr også data via API-er mot andre
            applikasjoner.
          </p>

          <List>
            <li>
              <a
                href="https://www.arbeiderpartiet.no/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Arbeiderpartiet.no
              </a>
            </li>
          </List>
        </Col>
      </Grid>

      <Contact
        who="tor"
        title="Vil du ta en prat om det vi har gjort for Arbeiderpartiet?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du lurer mer på hva vi har
        gjort for Arbeiderpartiet.
      </Contact>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Arbeiderpartiet/index.js